import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";

import { useAlert } from "react-alert";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { useDispatch, useSelector } from "react-redux";
import {
  getAssessments,
  deleteAssessmentData,
} from "../../../actions/adminAssessmentActions";
//import { deleteUserData } from '../../../actions/commonActions';

import Loader from "../../Loader";
// import Loader from "react-loader-spinner";
import { assessmentImageUrl } from "../../../utils/assets";

const ListAssessments = ({ history }) => {
  // const [users, setUsersData] = useState({});
  const alert = useAlert();
  const dispatch = useDispatch();

  const handleDeleteAssessment = (id) => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            dispatch(deleteAssessmentData(id));
            // history.push(`/admin/assessments`);
            alert.success("Assessment deleted successfully");
            dispatch(getAssessments());
          },
        },
        {
          label: "No",
          onClick: () => alert.success("No data deleted"),
        },
      ],
    });
  };

  useEffect(() => {
    dispatch(getAssessments());
  }, [dispatch]);

  const { assessments, user_loading } = useSelector((state) => state);

  return (
    <Fragment>
      {user_loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Manage
                <small>Assessments</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li className="active">Assessments</li>
              </ol>
            </section>

            <section className="content">
              <div className="row">
                <div className="col-xs-12">
                  <div className="box">
                    <div className="box-header">
                      <h3 className="box-title">Assessments</h3>
                      {/*<div className="box-tools">
                        <Link
                          to={"/admin/assessments/add"}
                          className="btn btn-success btn-sm"
                        >
                          + Add Assessment
                        </Link>
      </div>*/}
                    </div>
                    <div className="box-body table-responsive no-padding">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Assessment Name</th>
                            <th>Logo</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {assessments.user_loading ? (
                            <Loader />
                          ) : assessments.assessments.length ? (
                            assessments.assessments.map((item) => (
                              <tr key={item._id}>
                                <td>{item.title}</td>
                                <td>
                                  <img src={assessmentImageUrl(item.logo)} alt="Assessment" />
                                </td>
                                <td>
                                  {item.status === true && (
                                    <span className="badge bg-green">
                                      Active
                                    </span>
                                  )}
                                  {item.status === false && (
                                    <span className="badge bg-yellow">
                                      InActive
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <Link
                                    to={`/admin/assessments/edit/${item._id}`}
                                    className="btn btn-success btn-sm"
                                    title="Edit"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </Link>
                                  &nbsp;
                                  {/*<a
                                    className="btn btn-danger btn-sm"
                                    title="Delete"
                                    onClick={() =>
                                      handleDeleteAssessment(item._id)
                                    }
                                    key={item._id}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </a>*/}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2">No records found</td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot></tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ListAssessments;
